import { defineConfig } from 'sanity';
import { schemaTypes } from '../schemas';
import { structureTool } from 'sanity/structure';
import { visionTool } from '@sanity/vision';
import { RevalidateHomePage } from '../actions/homePageActions';
import { presentationTool } from 'sanity/presentation';
import { draftModeSecret, sanityProjectId, sanityDataset } from '../../../constants/envConfig';
import { createStructureConfig } from './structureConfig';
import { MyEnhancedNavbar } from '../components/StudioNavBar';
import { RevalidateAboutPage } from '../actions/aboutPageActions';
import { RevalidateContactPage } from '../actions/contactPageActions ';

export const createStudioConfig = (basePath: string, domainName: string) => {
    const origin = `https://${domainName}`;

    return defineConfig({
        name: 'default',
        projectId: sanityProjectId,
        dataset: sanityDataset,
        basePath: basePath,
        title: domainName,
        subtitle: 'production',
        studio: {
            components: {
                navbar: MyEnhancedNavbar,
            },
        },
        plugins: [
            structureTool({
                structure: createStructureConfig(domainName),
            }),
            visionTool(),
            presentationTool({
                previewUrl: {
                    origin,
                    preview: '/',
                    previewMode: {
                        enable: `/api/draft-mode/enable?path=/&secret=${draftModeSecret}`,
                        disable: '/api/draft-mode/disable',
                    },
                },
            }),
        ],
        schema: {
            types: schemaTypes,
        },
        document: {
            actions: (prev, context) => {
                const newActions = [...prev];

                if (context.schemaType === 'home_page') newActions.push(RevalidateHomePage);

                if (context.schemaType === 'aboutPage') newActions.push(RevalidateAboutPage);

                if (context.schemaType === 'contact_page') newActions.push(RevalidateContactPage);

                return newActions;
            },
        },
    });
};
